import { DICCIONARIO } from "../../constants/Diccionario";
import { REGEX_NIT2 } from "../../constants/Regex"
import { ErrorsHFilterForm, HFilterForm } from "../../interfaces/historial.interface";
import * as validators from '../validaciones'

const dateRangeValid = 30;

interface ValidationErrors {
  [key: string]: string
}

export const validateFilterInvoice = (input: HFilterForm, docs: Array<any>): ValidationErrors => {
    const errors: ValidationErrors = {}

    if (input.nit) { !REGEX_NIT2.test(input.nit) && (errors.nit = 'NIT inválido') }
    if (input.nrcEmisor) { input.nrcEmisor.length <= 1 && (errors.nrcEmisor = 'Mínimo 2 caracteres') }
    if (input.nrcReceptor) { input.nrcReceptor.length <= 1 && (errors.nrcReceptor = 'Mínimo 2 caracteres') }
    if (input.tipoDocCliente) { 
      let message = "";
      message = validators.validacionEsRequerido(
        input.documento,
        message,
        docs.find((tipo) => tipo.codigo === input.tipoDocCliente)?.valor
      )
      if (!message) message = validators.validacionMinLenght(input.documento, message, 3)
      if (!message)
        message = validators.validarTipoDocumento(
          docs.find((tipo) => tipo.codigo === input.tipoDocCliente)?.valor!,
          input.documento,
          message
        )
      errors.documento = message
    }
 
    (!input.tipoDTE || input.tipoDTE === "") && (errors.tipoDTE = `${DICCIONARIO.TIPO_DTE} requerido`)

    if (!input.fechaFinal) {
    } else {
      // Validar rango de 30 dias y superior
      if (!validateFinalDate(input.fechaInicial, input.fechaFinal)) { errors.fechaFinal = 'Fecha final debe ser mayor' }
      else if (!validateRangeDate(input.fechaInicial, input.fechaFinal)) { errors.fechaFinal = 'Rango inválido (30 días)' }
    }
    return errors
}


export const validateFinalDate = (date1: string, date2:  string) => {
    const dateConv1 = new Date(date1);
    const dateConv2 = new Date(date2);
    return dateConv1.getTime() <=  dateConv2.getTime();
}

export const validateRangeDate = (date1: string, date2:  string) => {
    const dateConv1 = new Date(date1);
    const dateConv2 = new Date(date2);

    // Calcula la diferencia en milisegundos entre las fechas
    const diferenciaMs:number = Math.abs(dateConv1.getTime() - dateConv2.getTime());

    // Calcula el número de días en la diferencia
    const diasDiferencia = diferenciaMs / (1000 * 60 * 60 * 24);

    // Compara si la separación es de al menos 30 días
    return diasDiferencia <= dateRangeValid;
}

export const validateFilterOnBlur = (
  input: HFilterForm,
  name: string,
  errors: ErrorsHFilterForm,
  docs: Array<any>
): HFilterForm => {

  switch (name) {
    case 'nit':
      if (!input.nit.trim()) errors.nit = '' 
      else if (!REGEX_NIT2.test(input.nit.trim())) errors.nit = 'NIT inválido'
      else errors.nit = ''
      break
    case 'tipoDocCliente':
      errors.documento = ''
      break
    case 'documento':
      if (input.tipoDocCliente) {
        let message = "";
        message = validators.validacionEsRequerido(
          input.documento,
          message,
          docs.find((tipo) => tipo.codigo === input.tipoDocCliente)?.valor
        )
        if (!message) message = validators.validacionMinLenght(input.documento, message, 3)
        if (!message)
          message = validators.validarTipoDocumento(
            docs.find((tipo) => tipo.codigo === input.tipoDocCliente)?.valor!,
            input.documento,
            message
          )
        errors.documento = message
      } else {
        errors.documento = ''
      }
      break
    case 'fechaInicial':
      // if (!input.fechaInicial.trim()) errors.fechaInicial = 'Fecha inicial requerida'
      // else errors.fechaInicial = ''
      break
    case 'fechaFinal':
      // if (!input.fechaFinal.trim()) errors.fechaFinal = 'Fecha final requerida'
      // else errors.fechaFinal = ''
      break
    case 'tipoDTE':
      if (!input.tipoDTE.trim() || input.tipoDTE === "") errors.tipoDTE = `${DICCIONARIO.TIPO_DTE} requerido`
      else errors.tipoDTE = ''
      break
  }

  return errors
}


